/**
 * @ngdoc services
 * @memberof mercury.modules.reports
 * @name ReportGrossProfit
 * @description Data access service for POS Items
 */
angular.module('mercury.modules.reports.grossprofit')
.factory('ReportGrossProfit', ["$http", "$resource", "$q", "settings", function($http, $resource, $q, settings) {
  var GrossProfitOverview = $resource(settings.mercHost + '/gross-profit/overview');
  // NOTE: This report while implemented has performance issues so is hidden
  var GrossProfitExpectedVsActual = $resource(settings.mercHost + '/gross-profit/expected-vs-actual');
  var GrossProfitPurchases = $resource(settings.mercHost + '/gross-profit/purchases');

  function getExpectedVsActual(startTime, endTime, interval) {
    return GrossProfitExpectedVsActual.query({start: startTime, end: endTime, interval: interval}).$promise;
  }

  function getPurchases(startTime, endTime, interval) {
    return GrossProfitPurchases.query({start: startTime, end: endTime, interval: interval}).$promise;
  }

  function getOverview(startTime, endTime, interval) {
    return GrossProfitOverview.query({start: startTime, end: endTime, interval: interval}).$promise;
  }

  return {
    getOverview: getOverview,
    getExpectedVsActual: getExpectedVsActual,
    getPurchases: getPurchases
  };
}]);
